import styles from "./PackContainerComponent.module.css";

const PackContainerComponent = (props) => {
  return (
    <>
      <div
        className={styles.container}
        style={
          props.backgroundColor
            ? { backgroundColor: `${props.backgroundColor}` }
            : null
        }
      >
        <div
          className={styles.inner}
          style={{
            flexDirection: `${props.orientation_lr ? "row" : "row-reverse"}`,
          }}
        >
          <div className={styles.image__container}>
            <div className={styles.image__inner}>
              <img
                src={props.mainImage}
                alt={props.image_alt}
                className={styles.image}
              />
            </div>
          </div>
          <div className={styles.text__container}>
            <div className={styles.text_inner}>
              <div className={styles.text_only}>
                <p className={styles.title}>{props.title}</p>
                <p className={styles.text}>{props.texte}</p>
              </div>
              <div className={styles.button__container}>
                <a
                  className={styles.button_link}
                  href={props.button_link}
                  target="__blank"
                >
                  {props.button_text}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PackContainerComponent;
